export default function(discount, discountConfiguration) {
  let discountType = "Discount";

  let discountCondition = "";

  if (!discount) {
    return "No discount configured";
  }

  if (discountConfiguration.selectedDiscountCodeOption === "existing") {
    discountType = "Using an existing discount code";
  }

  if (discountConfiguration.selectedDiscountCodeOption === "new") {
    if (discountConfiguration.discountValueType === "freeShipping") {
      discountType = `Free Shipping`;
    } else if (discountConfiguration.discountValueType === "percentage") {
      discountType = ` ${discount.newDiscountConfiguration.percentageDiscount}% Off`;
    } else if (discountConfiguration.discountValueType === "fixedValue") {
      if (discount.newDiscountConfiguration.fixedDiscount) {
        discountType = ` $${discount.newDiscountConfiguration.fixedDiscount.units}.00 Off`;
      }
    }

    if (
      discountConfiguration.discountMinimumRequirements === "purchaseAmount"
    ) {
      if (discount.newDiscountConfiguration.minimumPurchaseAmount) {
        discountCondition = ` When Spending At Least $${discount.newDiscountConfiguration.minimumPurchaseAmount.units}.00`;
      }
    } else if (
      discountConfiguration.discountMinimumRequirements === "quantityItems"
    ) {
      discountCondition = ` When Buying At Least ${discount.newDiscountConfiguration.minimumPurchaseQuantity} Item(s)`;
    }
  }
  return `${discountType}${discountCondition}`;
}
